<template>
    <div>
        <el-alert title="生效年份和名称必须唯一只能有一条记录，强行新增会覆盖。" type="info"  show-icon :closable="false"></el-alert>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="名称:" prop="name">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="年份:" prop="year">
                    <el-date-picker
                        size="mini"
                        v-model="searchForm.year"
                        type="year"
                        placeholder="选择年份"
                        format="yyyy"
                        value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysTimeSet-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysTimeSet-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                    <el-dropdown>
                        <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:sysTimeSet-batchDelete icon="el-icon-tickets" @click.native="batchCopy">复制上年度时间设置</el-dropdown-item>
                            <el-dropdown-item v-display:sysTimeSet-batchDelete icon="el-icon-delete" @click.native="batchDelete" >批量删除</el-dropdown-item>
                            <el-dropdown-item v-display:sysTimeSet-leadingIn icon="el-icon-upload" @click.native="leadingInsysTimeSet">导入</el-dropdown-item>
                            <el-dropdown-item v-display:sysTimeSet-export icon="el-icon-download" @click.native="exportsysTimeSet">导出</el-dropdown-item>
                            <el-dropdown-item v-display:sysTimeSet-exportModule icon="el-icon-download" @click.native="exportsysTimeSetModule('upsertForm')">下载模板</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
            </el-form>
        </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="50px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column show-overflow-tooltip prop="adminName" label="操作人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="是否发布">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color: green">发布</span>
                    <span v-else-if="scope.row.status==1" style="color: red">不发布</span>
                    <span v-else>未选择</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="startTime" label="开始时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="endTime" label="结束时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="year" label="生效年份">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.year && scope.row.year==new Date().getFullYear()" class="item" effect="dark" content="当前正在使用该记录进行时间控制" placement="top">
                        <span style="color: blue;font-weight: bold">{{scope.row.year}}<span class="el-icon-question" style="margin-left: 10px;color: blue;"></span></span>
                    </el-tooltip>
                    <el-tooltip v-else  class="item" effect="dark" :content="'到了“'+scope.row.year+'”系统将会获取这条记录的时间进行控制'" placement="top">
                        <span style="color: #615f5e;font-weight: bold">{{scope.row.year}}<span class="el-icon-question" style="margin-left: 10px;color: #615f5e;"></span></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><el-button type="text" v-display:sysTimeSet-update @click="showUpdateDialog(scope.row.id)">修改</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysTimeSet-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysTimeSet-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="550px" :visible.sync="dialog.dialogFormVisible">
            <div class="selectLong">
                <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                  <el-form-item label="名称" prop="name">
                     <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.name" placeholder="请输入名称" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="时间类型" prop="code">
                      <el-select v-model="upsertForm.code" size="mini" filterable  placeholder="请选择时间类型">
                          <el-option v-for="item in timeCodeList" :key="item.remark" :label="item.name" :value="item.remark">
                          </el-option>
                      </el-select>
                 </el-form-item>
                <el-form-item label="是否发布" prop="status">
                    <el-radio-group v-model="upsertForm.status" size="mini">
                        <el-radio-button label="0">发布</el-radio-button>
                        <el-radio-button label="1">不发布</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                  <el-form-item label="时间" prop="times">
                      <el-date-picker
                              size="mini"
                              v-model="upsertForm.times"
                              type="daterange"
                              align="right"
                              unlink-panels
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :picker-options="pickerOptions"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd">
                      </el-date-picker>
                  </el-form-item>
                <el-form-item label="生效年份" prop="year">
                    <el-date-picker
                            size="mini"
                            v-model="upsertForm.year"
                            type="year"
                            placeholder="选择生效年份"
                            format="yyyy"
                            value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysTimeSet-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysTimeSet-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="550px" :visible.sync="lookVisible">
            <div class="selectLong">
                <el-form class="upsertForm" :inline="true" label-width="100px">
                    <el-form-item label="操作人" prop="adminName">
                        <el-input size="mini" v-model="upsertForm.adminName" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="名称" prop="name">
                        <el-input size="mini" v-model="upsertForm.name" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="是否发布" prop="status">
                        <el-radio-group v-model="upsertForm.status" size="mini">
                            <el-radio-button label="0">发布</el-radio-button>
                            <el-radio-button label="1">不发布</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="编码" prop="code">
                        <el-input size="mini" v-model="upsertForm.code" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="startTime">
                        <el-input size="mini" v-model="upsertForm.startTime" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="endTime">
                        <el-input size="mini" v-model="upsertForm.endTime" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="生效年份" prop="year">
                        <el-input size="mini" v-model="upsertForm.year" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column prop="adminId" label="操作人编"></el-table-column>
                    <el-table-column prop="adminName" label="操作人"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="code" label="编码"></el-table-column>
                    <el-table-column prop="startTime" label="开始时间"></el-table-column>
                    <el-table-column prop="endTime" label="结束时间"></el-table-column>
                    <el-table-column prop="updateTime" label="修改时间"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                           style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                           :action="uploadUrl"
                           :headers="headers"
                           multiple
                           :show-file-list="false"
                           :on-success="handlesysTimeSetSuccess"
                           :before-upload="beforesysTimeSetUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportsysTimeSetModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    export default {
        name: "sysTimeSet",
        components: {
            ElFormItem,
            noData },
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                searchForm:{
                    adminId: '',
                    adminName: '',
                    name: '',
                    status:'',
                    code: '',
                    startTime: '',
                    endTime: '',
                    year:'',
                    updateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'year',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:"name"
                    }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    name:'',
                    status:'',
                    code:'',
                    startTime:'',
                    endTime:'',
                    year:'',
                    updateTime:'',
                    createTime:'',
                    times:[],
                },
                searchRules: {
                      adminId: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      adminName: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      name: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      code: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      startTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      endTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      updateTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      createTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                },
                rules: {
                    adminId: [
                        {required: true, message: '请输入操作人编', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    adminName: [
                        {required: true, message: '请输入操作人', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择是否发布', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, message: '请输入编码', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    startTime: [
                        {required: true, message: '请输入开始时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    endTime: [
                        {required: true, message: '请输入结束时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    year: [
                        {required: true, message: '请选择生效年份', trigger: 'blur'},
                    ],
                    updateTime: [
                        {required: true, message: '请输入修改时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    createTime: [
                        {required: true, message: '请输入创建时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    times: [
                        {required: true, message: '请选择时间', trigger: 'blur'},
                    ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysTimeSet/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                timeCodeList:[],
                yearList:[],
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getTimeCodeList();
        },
        mounted(){
            this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysTimeSet/update/findSysTimeSetById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    if(res.data.startTime && res.data.endTime){
                        this.upsertForm.times = (res.data.startTime + ','+res.data.endTime).split(",");
                    }
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{
                    console.log(error);
                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        if(this.upsertForm.times && this.upsertForm.times.length>0){
                            this.upsertForm.startTime = this.upsertForm.times[0];
                            this.upsertForm.endTime = this.upsertForm.times[1];
                        }
                        axios({
                            url:`${home}/sysTimeSet/${this.dialog.title==='增加'?'saveSysTimeSet':'update/updateSysTimeSet'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysTimeSet/deleteSysTimeSet/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysTimeSet/findSysTimeSetsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysTimeSet/look/lookSysTimeSetById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInsysTimeSet() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportsysTimeSet() {
                axios({
                    url: `${home}/sysTimeSet/exportSysTimeSet`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysTimeSet.xls");
                });
            },
            exportsysTimeSetModule() {
                axios({
                    url: `${home}/sysTimeSet/exportSysTimeSetModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysTimeSet模板.xls");
                });

            },
            handlesysTimeSetSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysTimeSetUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysTimeSet/batchDeleteSysTimeSet`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            getTimeCodeList(){
                axios({
                    url: `${home}/sysDdList/getTimeCodeList`,
                    method: "GET",
                }).then(res => {
                    this.timeCodeList = res.data;
                    this.yearList = res.data2;
                }).catch(error => {});
            },
          batchCopy(){
            this.$prompt('请输入年份', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /^(19|20)\d{2}$/,
              inputErrorMessage: '年份格式不正确'
            }).then(({ value }) => {
              axios({
                url: `${home}/sysTimeSet/batchCopySysTimeSetByYear/${value}`,
                method: "GET",
              }).then(res => {
                this.$message({
                  type: "success",
                  message: "复制成功!"
                });
                this.submit();
              }).catch(error => {});
            }).catch(() => {
              this.$message({
                type: "error",
                message: "复制失败!"
              });
            });
          }

        }
    }
</script>
<style lang="scss">
    .selectLong{
        .el-input {
            width: 350px;
        }
    }
</style>
